import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../services/apiService';

export const useModalActions = (onClose: () => void) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const createOperation = async (formData: any, mode: 'MS' | 'BC' = 'MS') => {
    setIsSubmitting(true);

    try {
      let result;

      if (mode === 'BC') {
        // Payload correct pour l'API /bdc/operation
        const commandeData = {
          nom: formData.nomOperation,
          id_lot_technique: formData.lotTechnique, // Ajouté
          id_lot_departement: formData.lotGeographique, // Corrigé: utiliser lotGeographique au lieu de departement
        };

        try {
          // Utiliser la nouvelle API pour les bons de commande
          result = await apiService.createBonCommande(commandeData);

          onClose();
          // Onglet par KIND (resolu par useOperationTabs) plutot que par index : `consultation` vise
          // le premier onglet de ce kind, soit le rang 1. Le hash amene l'acheteur directement au
          // "Descriptif Financier", ou il compose sa commande — c'est la suite naturelle du catalogue.
          navigate(`/operation-bc/${result.id}?tab=consultation#descriptif-financier`);
        } catch (apiError: any) {
          // Enrichir l'erreur avec les informations nécessaires pour l'affichage
          const error: any = new Error(apiError.message || 'Une erreur est survenue');
          error.status = apiError.status || 500;

          // Si c'est une erreur 400, s'assurer que le message est disponible
          if (error.status === 400 && apiError.data && apiError.data.message) {
            error.message = apiError.data.message;
          }

          throw error;
        }
      } else {
        const operationData = {
          nom: formData.nomOperation,
          id_lot_technique: formData.lotTechnique,
          id_lot_departement: formData.lotGeographique || formData.departement,
          commentaire: "",
          delais: "",
          visite: "",
          expire_at: formData.expire_at,
        };

        try {
          result = await apiService.createOperation(operationData);

          onClose();
          navigate(`/operation-ms/${result.id}?tab=1`);
        } catch (apiError: any) {
          // Enrichir l'erreur avec les informations nécessaires pour l'affichage
          const error: any = new Error(apiError.message || 'Une erreur est survenue');
          error.status = apiError.status || 500;

          // Si c'est une erreur 400, s'assurer que le message est disponible
          if (error.status === 400 && apiError.data && apiError.data.message) {
            error.message = apiError.data.message;
          }

          throw error;
        }
      }

      return result;
    } catch (error) {
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    createOperation,
    isSubmitting
  };
};